export { default as statusesQueries } from './basic'